export const boundariesProfitOriented = [
  [5000, 5000],
  [4744, 5315],
  [4653, 5465],
  [4589, 5589],
  [4539, 5699],
  [4498, 5801],
  [4463, 5897],
  [4432, 5989],
  [4405, 6077],
  [4381, 6163],
  [4360, 6247],
  [4340, 6329],
  [4322, 6410],
  [4306, 6489],
  [4291, 6568],
  [4277, 6645],
  [4265, 6722],
  [4253, 6798],
  [4242, 6874],
  [4233, 6949],
  [4223, 7024],
  [4215, 7099],
  [4207, 7173],
  [4200, 7247],
  [4193, 7321],
  [4187, 7395],
  [4181, 7469],
  [4176, 7542],
  [4171, 7616],
  [4167, 7689],
  [4163, 7763],
  [4159, 7836],
  [4156, 7910],
  [4153, 7983],
  [4151, 8057],
  [4148, 8131],
  [4146, 8205],
  [4144, 8279],
  [4143, 8353],
  [4142, 8428],
  [4141, 8502],
  [4140, 8577],
  [4139, 8652],
  [4139, 8727],
  [4139, 8802],
  [4139, 8877],
  [4139, 8953],
  [4140, 9029],
  [4140, 9105],
  [4141, 9182],
  [4142, 9259],
  [4143, 9336],
  [4144, 9413],
  [4146, 9490],
  [4148, 9568],
  [4149, 9646],
  [4151, 9725],
  [4153, 9803],
  [4155, 9882],
  [4158, 9962],
  [4160, 10041],
  [4163, 10121],
  [4166, 10202],
  [4168, 10282],
  [4171, 10363],
  [4174, 10445],
  [4178, 10527],
  [4181, 10609],
  [4184, 10691],
  [4188, 10774],
  [4192, 10857],
  [4195, 10941],
  [4199, 11024],
  [4203, 11109],
  [4207, 11193],
  [4211, 11279],
  [4215, 11364],
  [4220, 11450],
  [4224, 11536],
  [4229, 11623],
  [4233, 11710],
  [4238, 11798],
  [4243, 11886],
  [4248, 11974],
  [4253, 12063],
  [4258, 12152],
  [4263, 12242],
  [4268, 12332],
  [4273, 12422],
  [4279, 12514],
  [4284, 12605],
  [4290, 12697],
  [4295, 12789],
  [4301, 12882],
  [4307, 12976],
  [4313, 13069],
  [4318, 13164],
  [4324, 13258],
  [4330, 13354],
  [4337, 13449],
  [4343, 13546],
  [4349, 13642],
  [4355, 13740],
  [4362, 13837],
  [4368, 13936],
  [4375, 14034],
  [4381, 14134],
  [4388, 14233],
  [4395, 14334],
  [4402, 14434],
  [4409, 14536],
  [4415, 14638],
  [4422, 14740],
  [4430, 14843],
  [4437, 14947],
  [4444, 15051],
  [4451, 15155],
  [4458, 15260],
  [4466, 15366],
  [4473, 15472],
  [4481, 15579],
];

export const developmentProfitOriented = [
  5000, 5024, 5049, 5074, 5098, 5123, 5148, 5174, 5199, 5224, 5250, 5276, 5301, 5327,
  5353, 5379, 5406, 5432, 5459, 5485, 5512, 5539, 5566, 5593, 5621, 5648, 5676, 5704,
  5731, 5760, 5788, 5816, 5844, 5873, 5902, 5931, 5960, 5989, 6018, 6047, 6077, 6107,
  6136, 6166, 6197, 6227, 6257, 6288, 6319, 6350, 6381, 6412, 6443, 6475, 6506, 6538,
  6570, 6602, 6634, 6667, 6699, 6732, 6765, 6798, 6831, 6865, 6898, 6932, 6966, 7000,
  7034, 7069, 7103, 7138, 7173, 7208, 7243, 7278, 7314, 7350, 7386, 7422, 7458, 7495,
  7531, 7568, 7605, 7642, 7680, 7717, 7755, 7793, 7831, 7869, 7908, 7946, 7985, 8024,
  8063, 8103, 8142, 8182, 8222, 8262, 8303, 8343, 8384, 8425, 8466, 8508, 8549, 8591,
  8633, 8675, 8718, 8760, 8803, 8846, 8889, 8933, 8976,
];

export const fluctuationProfitOriented = [
  5000, 5019, 5288, 5505, 5686, 5733, 5610, 5579, 5532, 5307, 4942, 5036, 5301, 5669,
  5930, 6220, 6348, 6368, 6397, 6417, 6322, 6285, 6272, 5982, 5621, 5366, 5343, 5691,
  6124, 6277, 6253, 5989, 5934, 5811, 5914, 6024, 5960, 5760, 6014, 5825, 5843, 5965,
  5883, 5768, 5975, 6390, 6231, 6006, 6319, 6364, 6524, 6671, 7146, 7598, 7759, 7443,
  7207, 7181, 6874, 6705, 6699, 6671, 6489, 6585, 7017, 7486, 7783, 7991, 7998, 7853,
  7654, 7438, 7103, 7137, 7567, 8052, 8110, 8218, 8451, 8455, 8284, 8375, 8048, 7482,
  7531, 7721, 7675, 7378, 7057, 6819, 6733, 6792, 6809, 7205, 7795, 7874, 7985, 7704,
  7185, 6912, 7188, 7342, 7474, 7455, 7424, 7517, 7771, 8288, 8466, 8943, 8990, 9373,
  10017, 10200, 10023, 9716, 9183, 8981, 9212, 9122, 8976,
];
